import React, { useState } from 'react';
import { Edit3, Calendar, Play, Volume2, Image, Eye } from 'lucide-react';

const TileCard = ({ tile, onTileClick, onEditTile }) => {
  const [imageError, setImageError] = useState(false);
  const [videoError, setVideoError] = useState(false);
  const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};

  const getMediaIcon = (mediaType) => {
    switch (mediaType) {
      case 'video': return <Play className="w-4 h-4" />;
      case 'audio': return <Volume2 className="w-4 h-4" />;
      case 'image': return <Image className="w-4 h-4" />;
      default: return <Eye className="w-4 h-4" />;
    }
  };

  return (
    <div className="group relative bg-gradient-to-br from-purple-600/10 to-purple-800/10 backdrop-blur-sm border border-purple-500/20 rounded-xl p-6 transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:shadow-purple-500/20 cursor-pointer flex flex-col h-64 overflow-hidden"
     onClick={() => onTileClick(tile)}
    >
      {/* Centered Title Section */}
      <div className="flex-1 flex flex-col items-center justify-center mb-2 px-2 pt-4">
        <h3 className="text-xl font-bold text-purple-400 group-hover:text-purple-300 transition-colors duration-200 text-center line-clamp-3 w-full">
          {tile.title}
        </h3>
        {user.isAdmin && (tile.createdBy?.username === user.username || tile.createdBy?._id === user.id) && (
          <button
            onClick={(e) => {
              e.stopPropagation();
              onEditTile(tile);
            }}
            className="mt-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 p-2 rounded-full hover:bg-purple-600/20"
          >
            <Edit3 className="w-4 h-4 text-purple-400" />
          </button>
        )}
      </div>
      
      {/* Footer Info */}
      <div className="flex-shrink-0 space-y-2">
        <div className="flex items-center justify-between text-xs text-purple-300/70">
          <div className="flex items-center gap-2">
            {getMediaIcon(tile.mediaType)}
            <span className="capitalize">{tile.mediaType}</span>
          </div>
          <div className="flex items-center gap-1">
            <Calendar className="w-3 h-3" />
            <span>{tile.memoryDate ? new Date(tile.memoryDate).toLocaleDateString() : new Date(tile.createdAt).toLocaleDateString()}</span>
          </div>
        </div>
        
        {/* Created by */}
        <div className="text-xs text-purple-300/50 text-center">
          by {tile.createdBy?.username || 'Unknown'}
        </div>
      </div>
      
      {/* Click overlay */}
      {/* <div 
        className="absolute inset-0 z-10 cursor-pointer"
        onClick={() => onTileClick(tile)}
      /> */}
    </div>
  );
};

export default TileCard;